$(document).ready(function(){
  $('.js-load-more').on('click', function () {
    var $this = $(this),
        totalPages = parseInt($('[data-total-pages]').val()),
        currentPage = parseInt($('[data-current-page]').val());

    // Increment page number before generating nextUrl
    var nextPage = currentPage + 1;

    // Disable button and show loader
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var fullUrl = $('[data-next-url]').val().split('?page=');
    if (window.location.pathname.indexOf('/collections') === 0) {
      var nextUrl = fullUrl[0] + '?page=' + nextPage;
    } else {
      var nextUrl = $('[data-next-url]').val().replace(/page=\d+/, 'page=' + nextPage);
    }

    // console.log(nextUrl)
    

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        // Append new content
        $('#ProductGridContainer #product-grid.product-grid').append($(responseHTML).find('#ProductGridContainer #product-grid.product-grid').html());

        // Update current page
        $('[data-current-page]').val(nextPage);
        // console.log(responseHTML);
        // Prepare next URL only if more pages exist
        if (nextPage < totalPages) {
          var newNextUrl = nextUrl.replace(/page=\d+/, 'page=' + (nextPage + 1));
          $('[data-next-url]').val(newNextUrl);
        } else {
          // Optionally hide or disable the button if all pages are loaded
          $this.hide();
        }
      },
      complete: function () {
        if (nextPage <= totalPages) {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        }
      }
    });
  });
  const toggleButton = document.querySelector(".read-more-toggle");
  const textSpan = document.querySelector(".read-more-text");

  // if (fulltext && toggleButton) {
  //     const heightThreshold = '72px'; 
  //     const actualHeight = fulltext.offsetHeight;
  //     if (actualHeight >= heightThreshold) {
  //       toggleButton.style.display = "block!important";
  //     } else {
  //       toggleButton.style.display = "none";
  //     }
  //   }
  if(toggleButton){
      toggleButton.addEventListener("click", function () {
      textSpan.classList.toggle("expanded");
      toggleButton.textContent = textSpan.classList.contains("expanded") ? "Read less" : "Read more";
    });
  }
  
  $('.slideshow').slick({
    slidesToShow: 1,
    dots:$('.slideshow').attr('data-dots') === 'true',
    arrows: $('.slideshow').attr('data-arrow') === 'true',
    touchThreshold: 500,
    autoplay:$('.slideshow').attr('data-autoplay') === 'true',
    autoplaySpeed:$('.slideshow').attr('data-speed'),
    infinite: false
  });
  
  $('.announcement-bar-container.multi-bar').slick({
    slidesToShow: 1,
    dots:false,
    arrows: false,
    touchThreshold: 500,
    autoplay:true,
    infinite: true
  });

  $('.feature_collection').each(function() {
    var section_id = $(this).attr('data-id');
    var $slider = $('.feature_collection[data-id="'+section_id+'"] .collection slider-component .slider');
  
    $slider.slick({
      slidesToShow: parseInt($slider.attr('data-desk-slide'), 10),
      dots: true,
      arrows: true,
      slidesToScroll: 1,
      touchThreshold: 500,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  });

  var $slider = $('.featured_blog .blog__posts');
  
    $slider.slick({
      slidesToShow: parseInt($slider.attr('data-desk-slide'), 10),
      dots: true,
      arrows: false,
      slidesToScroll: 1,
      touchThreshold: 500,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  
});